import { render, staticRenderFns } from "./addHeaderFooter.vue?vue&type=template&id=7c8498fe&scoped=true"
import script from "./addHeaderFooter.vue?vue&type=script&lang=js"
export * from "./addHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8498fe",
  null
  
)

export default component.exports